// extracted by mini-css-extract-plugin
export default {"title":"ArchivedScriptHeader_title__5ZEv0","separator":"ArchivedScriptHeader_separator__tBBWj"};